var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeSize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 16,
    height: 14,
    rx: 1.5,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8V7.25H6.25V8H7ZM9.46967 11.5303C9.76256 11.8232 10.2374 11.8232 10.5303 11.5303C10.8232 11.2374 10.8232 10.7626 10.5303 10.4697L9.46967 11.5303ZM7.75 12V8H6.25V12H7.75ZM7 8.75H11V7.25H7V8.75ZM6.46967 8.53033L9.46967 11.5303L10.5303 10.4697L7.53033 7.46967L6.46967 8.53033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16V16.75H17.75V16H17ZM14.5303 12.4697C14.2374 12.1768 13.7626 12.1768 13.4697 12.4697C13.1768 12.7626 13.1768 13.2374 13.4697 13.5303L14.5303 12.4697ZM16.25 12V16H17.75V12H16.25ZM17 15.25H13V16.75H17V15.25ZM17.5303 15.4697L14.5303 12.4697L13.4697 13.5303L16.4697 16.5303L17.5303 15.4697Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeSize);
export default __webpack_public_path__ + "static/media/change-size.ce844e66c1ac7a08a6c266919fdcad95.svg";
export { ForwardRef as ReactComponent };